import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ImageReviewCard } from "@/components/ImageReviewCard";

/** Right-side inspector: original vs. every version of one image. `technical` (Lab) adds metrics and per-image review. */
export const ImageInspector = ({ image, open, onOpenChange, onReview, busy, technical = true }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="right" className="w-full sm:max-w-2xl overflow-y-auto p-0 bg-background" data-testid="image-inspector">
      <SheetHeader className="px-5 pt-6 pb-3 text-left">
        <SheetTitle className="font-heading text-[26px] tracking-[-0.02em]">{image?.room_label || "Bilde"}{technical && <span className="ml-2 font-mono text-xs text-svak font-normal tracking-normal">{image?.external_image_id}</span>}</SheetTitle>
        <SheetDescription>Dra i glideren for å sammenligne originalen med hver versjon.</SheetDescription>
      </SheetHeader>
      <div className="px-5 pb-8">
        {image && <ImageReviewCard image={image} onReview={onReview} busy={busy} compact technical={technical} />}
      </div>
    </SheetContent>
  </Sheet>
);
